import { IApplicationState } from '../../types/redux';

export const getQuestionText = (state: IApplicationState): string => {
  return state.newQuestion.text;
};
